<app-alerts />

<app-admin-product-details-form
  (submitClickEvent)="handleSubmitClickEvent($event)" />
